export interface CreateGameResponse {
  gameCode: string;
  participantId: string;
  role: "TDC";
  token: string;
}

export interface JoinGameResponse {
  gameCode: string;
  participantId: string;
  role: "PHC";
  token: string;
  isWaiting: boolean;
}

export async function apiCreateGame(args?: {
  gameName?: string;
  password?: string;
}): Promise<CreateGameResponse> {
  const res = await fetch("/api/games", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(args ?? {}),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    if (res.status === 401 && body.error === "invalid_password") {
      throw new Error("invalid_password");
    }
    throw new Error(`create_game_failed:${res.status}`);
  }
  return (await res.json()) as CreateGameResponse;
}

export async function apiJoinGame(args: {
  code: string;
  name: string;
  color: string;
}): Promise<JoinGameResponse> {
  const res = await fetch("/api/games/join", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(args),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(`join_failed:${res.status}:${JSON.stringify(body)}`);
  }
  return (await res.json()) as JoinGameResponse;
}

export async function apiResume(token: string): Promise<{
  ok: boolean;
  gameCode?: string;
  participantId?: string;
  role?: "TDC" | "PHC";
}> {
  const res = await fetch("/api/games/resume", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ token }),
  });
  if (!res.ok) return { ok: false };
  return (await res.json()) as { ok: boolean; gameCode: string; participantId: string; role: "TDC" | "PHC" };
}

export async function apiGameExists(code: string): Promise<{
  exists: boolean;
  gameName?: string | null;
  phase?: string;
}> {
  const res = await fetch(`/api/games/${code}/exists`);
  if (!res.ok) return { exists: false };
  return (await res.json()) as { exists: boolean; gameName?: string | null; phase?: string };
}
